/*
 * @Author: csu chen.su@murata.com
 * @Date: 2022-06-22 15:36:49
 * @LastEditors: csu chen.su@murata.com
 * @LastEditTime: 2024-01-11 14:04:59
 * @FilePath: \frontend\src\utils\userFunctionList.js
 */
import Layout from '@/layout/index.vue';
import { i18n } from '@/Lang/index.js';

const routerMap = new Map([
  ['dashboard', import('@/views/dashboard/index.vue')],
  ['maintenance', import('@/views/maintenance/index.vue')],
  ['devices', import('@/views/devices/index.vue')],
  // ['systemInfo', import('@/views/system/systemInfo.vue')],
  // ['systemTime', import('@/views/system/systemTime.vue')],
  // ['systemNetwork', import('@/views/system/systemNetwork.vue')],
  // ['tfCardInfo', import('@/views/system/tfCardInfo.vue')],
  // ['csvLog', import('@/views/system/csvLog.vue')],
  // ['subGwConfig', import('@/views/system/subGwConfig.vue')],
  ['userManagement', import('@/views/userManagement/index.vue')],
  // ['alertHistory', import('@/views/alert/alertHistory.vue')],
  // ['alertCondition', import('@/views/alert/alertCondition.vue')],
  // ['alertEmail', import('@/views/alert/alertEmail.vue')],
  ['map', import('@/views/map/index.vue')],
  // ['csv', 'http://' + document.domain + '/ftp']
  // ['downloadCsvFile', import('@/views/tfCard/downloadCsvFile.vue')],
  // ['subgConfig', import('@/views/system/subgConfig.vue')],
  // ['about', import('@/views/system/about.vue')],
  ['gateways', import('@/views/gateways/index.vue')],
  ['areas', import('@/views/areas/index.vue')],
]);

const titleMap = new Map([
  ['Dashboard', i18n.global.t('router.dashboard')],
  ['Maintenance', i18n.global.t('router.maintenance')],
  ['Devices', i18n.global.t('router.devices')],
  // ['Alert', i18n.global.t('router.alert')],
  // ['Alert History', i18n.global.t('router.alertHistory')],
  // ['Alert Email', i18n.global.t('router.alertEmail')],
  // ['Alert Condition', i18n.global.t('router.alertCondition')],
  ['User Management', i18n.global.t('router.userManagement')],
  // ['System Setting', i18n.global.t('router.systemSetting')],
  // ['System Info', i18n.global.t('router.systemInfo')],
  // ['System Time', i18n.global.t('router.systemTime')],
  // ['System Network', i18n.global.t('router.systemNetwork')],
  ['Map', i18n.global.t('router.map')],
  // ['Tf Card Info', i18n.global.t('router.tfCardInfo')],
  // ['CSV Log', i18n.global.t('router.log')],
  // ['Sub-Gateway Config', i18n.global.t('router.subGwCfg')],
  // ['SubG Config', i18n.global.t('router.subgConfig')],
  // ['About', i18n.global.t('router.about')],
  ['Gateways', i18n.global.t('router.gateways')],
  ['Areas', i18n.global.t('router.areas')],
]);

export function initFunctionList(data, mode, isAdmin) {
  const userRouter = [];
  const parentRouter = [];
  const childrenRouter = [];
  const rootFunc = isAdmin ? 'Areas' : 'Gateways';

  for (const func of data) {
    if (func.parent_id != null) {
      childrenRouter.push(func);
    } else {
      parentRouter.push(func);
    }
  }

  for (const parent of parentRouter) {
    // if (parent.func_api === 'csv') {
    //   userRouter.push({
    //     'path': 'external-link',
    //     'children': [
    //       {
    //         'path': routerMap.get(parent.func_api),
    //         'meta': { 'title': parent.func_name, 'icon': parent.func_icon }
    //       }
    //     ]
    //   })
    //   continue
    // }

    const children = [];
    for (const child of childrenRouter) {
      if (child.parent_id === parent.func_id) {
        const json = {
          // path: child.func_name === 'Dashboard' ? '/' : '/' + transformStr(child.func_path),
          path: child.func_name === rootFunc ? '/' : '/' + transformStr(child.func_path),
          component: () => routerMap.get(child.func_api),
          name: transformStr(child.func_name),
          meta: {
            title: titleMap.get(child.func_name),
            icon: child.func_icon,
          },
        };
        children.push(json);
      }
    }

    if (children.length === 0) {
      const json = {
        // path: parent.func_name === 'Dashboard' ? '/' : '/' + transformStr(parent.func_path),
        path: parent.func_name === rootFunc ? '/' : '/' + transformStr(parent.func_path),
        component: Layout,
        children: [
          {
            path: '',
            name: transformStr(parent.func_name),
            component: () => routerMap.get(parent.func_api),
            meta: {
              title: titleMap.get(parent.func_name),
              icon: parent.func_icon,
            },
          },
        ],
      };
      userRouter.push(json);
      /*
      if (parent.func_api === 'downloadCsvFile') {
        const json = {
          path: '/' + transformStr(parent.func_path),
          component: () => routerMap.get(parent.func_api),
          hidden: true,
        };
        userRouter.push(json);
      } else {
        const json = {
          // path: parent.func_name === 'Dashboard' ? '/' : '/' + transformStr(parent.func_path),
          path: parent.func_name === 'Areas' ? '/' : '/' + transformStr(parent.func_path),
          component: Layout,
          children: [
            {
              path: '',
              name: transformStr(parent.func_name),
              component: () => routerMap.get(parent.func_api),
              meta: {
                title: titleMap.get(parent.func_name),
                icon: parent.func_icon,
              },
            },
          ],
        };
        userRouter.push(json);
      }
      */
    } else {
      const json = {
        // path: parent.func_name === 'Dashboard' ? '/' : '/' + transformStr(parent.func_path),
        path: parent.func_name === rootFunc ? '/' : '/' + transformStr(parent.func_path),
        component: Layout,
        name: transformStr(parent.func_name),
        meta: {
          title: titleMap.get(parent.func_name),
          icon: parent.func_icon,
        },
        children: children,
      };
      userRouter.push(json);
    }
  }
  /*
  if (mode === 1) {
    userRouter.push({
      path: '/',
      component: Layout,
      children: [
        {
          path: '',
          name: transformStr('System Network'),
          component: () => routerMap.get('systemNetwork'),
          meta: {
            title: titleMap.get('System Network'),
            icon: 'network',
          },
        },
      ],
      hidden: true,
    });
  }
  */
  userRouter.push({
    path: '/:pathMatch(.*)*',
    redirect: '/404',
    hidden: true,
  });

  // for (const route of userRouter) {
  //   if (route.name === 'Devices') {
  //     route.props = true;
  //     break;
  //   }
  // }

  return userRouter;
}

// Convert initial letter of word to uppercase
function transformStr(str) {
  var strArr = str.split(' ');
  for (var i = 1; i < strArr.length; i++) {
    strArr[i] = strArr[i].charAt(0).toUpperCase() + strArr[i].substring(1);
  }
  return strArr.join('');
}
